/**
 * @fileoverview "Coming soon" body of the Capabilities screen's Banking tab.
 * @description The design shows no Banking matrix yet, so the Banking tab says so rather than
 * staying empty. Replace this with the real matrix once Banking roles get capabilities.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useTranslation } from 'react-i18next'

/**
 * @component
 */
function BankingCapabilitiesPlaceholder() {
  const { t } = useTranslation()

  return (
    <section
      className="flex flex-col items-center gap-2.5 rounded-[10px] border border-divider bg-white px-5 py-14 text-center"
      data-testid="capabilities-banking-placeholder"
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="text-footer"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />
      </svg>
      <p className="text-base font-semibold text-ink" data-testid="capabilities-banking-title">
        {t('capabilities.banking.comingSoonTitle')}
      </p>
      <p className="max-w-[420px] text-sm text-slate" data-testid="capabilities-banking-text">
        {t('capabilities.banking.comingSoonText')}
      </p>
    </section>
  )
}

export default BankingCapabilitiesPlaceholder
